export default __webpack_public_path__ + "static/media/under-construction.5503eb03.svg";